import client from '../client';

export const getBotList = () =>
    client.get('/api/chat/bots');